import WebRtcPlayer, {
  isWebRTCAPISupported,
  PlayerEvents,
  SignalController,
  GbsSignalController,
  TencentSignalController,
} from './index';

// @ts-ignore
WebRtcPlayer.isWebRTCAPISupported = isWebRTCAPISupported;
// @ts-ignore
WebRtcPlayer.Events = PlayerEvents;
// @ts-ignore
WebRtcPlayer.SignalController = SignalController;
// @ts-ignore
WebRtcPlayer.GbsSignalController = GbsSignalController;
// @ts-ignore
WebRtcPlayer.TencentSignalController = TencentSignalController;

export default WebRtcPlayer;
